/* eslint-disable react-hooks/exhaustive-deps */
import {
    Box,
    Flex,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Text,
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    ModalHeader,
    Textarea,
    VStack,
    Input,
    RadioGroup,
    HStack,
    Radio,
    Select,
    Image,
    Spinner,
    InputGroup,
    InputLeftElement,
    SimpleGrid,
    Checkbox,
    Divider,
    Tag,
    TagLabel,
    IconButton,
    Center,
} from '@chakra-ui/react';
import {
    SearchIcon,
    ChevronDownIcon,
    PlusSquareIcon,
    CheckCircleIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
} from '@chakra-ui/icons';
import { oBIcons } from '../components/Icons';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Paystack from '@paystack/inline-js';
import useGetUserDetails from 'hooks/useGetUserDetail';
import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';
import p1 from '../../../assets/placeholder.png';
import { useGetSampleRequest, useSampleRequestMutations } from 'hooks/useSampleRequest';
import moment from 'moment';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { useUSDToNairaCurrency } from 'hooks/useCurrency';
import Loader from 'components/loader';
import { useGetQoutesAndCarriers } from 'hooks/useGetLocations';
import { useGetProducts } from 'hooks/useProducts';
import CustomerStep from 'components/CustomerStep';
import { formatPhoneNumberInternational } from 'utils/phoneformatter';
import isoCountries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';

isoCountries.registerLocale(en);

const NAVY = '#1B3B5F';
const NAVY2 = '#162f4e';
const TEAL = '#0D9488';
const SLATE = '#F8FAFC';
const BORDER = '#E2E8F0';

const STORE_OPEBI = {
    id: 'opebi',
    carrier_id: 'opebi',
    name: 'Warehouse Pickup – Opebi',
    address: {
        line1: '77 Opebi Road',
        city: 'Ikeja',
        state: { label: 'Lagos', value: 'Lagos' },
        country: { label: 'NG', value: 'Nigeria' },
        phone: '+234800335245',
    },
    amount: 0,
    delivery_time: 'Same-day Pickup',
    carrier_rate_description: 'Fulfilment Centre Pickup',
};

// ── helpers ────────────────────────────────────────────────────────────────────
const resolveImage = (item) => {
    if (!item) return null;
    const cf = item.cf_singleimage ?? item.custom_field_hash?.cf_singleimage;
    if (cf) {
        try {
            const p = JSON.parse(cf);
            if (Array.isArray(p) && p[0]) return p[0];
            if (typeof p === 'string' && p.startsWith('http')) return p;
        } catch {
            if (typeof cf === 'string' && cf.startsWith('http')) return cf;
        }
    }
    return item.image_name ?? item.image ?? null;
};

const parseDeliveryAddress = (raw) => {
    try {
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
};

const parseSampleDetails = (raw) => {
    try {
        return raw ? (typeof raw === 'string' ? JSON.parse(raw) : raw) : null;
    } catch {
        return null;
    }
};

// ── ProductPickerModal ─────────────────────────────────────────────────────────
const ProductPickerModal = ({ isOpen, onClose, selectedProducts, onConfirm }) => {
    const [search, setSearch] = useState('');
    const [localSelected, setLocal] = useState(selectedProducts ?? []);
    const [page, setPage] = useState(1);
    const PER_PAGE = 20;

    const { data, isLoading } = useGetProducts({
        search: search || undefined,
        per_page: PER_PAGE,
        page,
    });
    const items = data?.items ?? [];

    useEffect(() => {
        setLocal(selectedProducts ?? []);
    }, [isOpen]);

    const toggle = (item) =>
        setLocal((prev) =>
            prev.find((p) => p.item_id === item.item_id)
                ? prev.filter((p) => p.item_id !== item.item_id)
                : [...prev, item],
        );
    const isSelected = (item) => localSelected.some((p) => p.item_id === item.item_id);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size={{ base: 'full', md: '3xl' }}
            scrollBehavior="inside">
            <ModalOverlay bg="blackAlpha.500" backdropFilter="blur(4px)" />
            <ModalContent
                borderRadius={{ base: '2xl 2xl 0 0', md: '2xl' }}
                maxH={{ base: '92vh', md: '90vh' }}
                border={`1px solid ${BORDER}`}
                shadow="2xl"
                mx={{ base: 0, md: 'auto' }}
                mb={{ base: 0, md: 'auto' }}
                mt={{ base: 'auto', md: 'auto' }}
                position={{ base: 'fixed', md: 'relative' }}
                bottom={{ base: 0, md: 'auto' }}
                w={{ base: '100%', md: 'auto' }}>
                <ModalHeader
                    bg={NAVY}
                    color="white"
                    borderTopRadius="2xl"
                    py={5}
                    px={5}
                    fontSize="md"
                    fontWeight="700">
                    🛍 Select Products
                </ModalHeader>
                <ModalCloseButton color="white" top={4} />
                <ModalBody pt={5} pb={4} px={{ base: 4, md: 6 }}>
                    <InputGroup mb={4}>
                        <InputLeftElement pointerEvents="none">
                            <SearchIcon color="gray.400" />
                        </InputLeftElement>
                        <Input
                            placeholder="Search by name or SKU…"
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(1);
                            }}
                            bg={SLATE}
                            border={`1px solid ${BORDER}`}
                            borderRadius="xl"
                            _focus={{ borderColor: TEAL }}
                        />
                    </InputGroup>

                    {localSelected.length > 0 && (
                        <Flex
                            flexWrap="wrap"
                            gap={2}
                            mb={4}
                            p={3}
                            bg="teal.50"
                            borderRadius="xl"
                            border="1px solid"
                            borderColor="teal.100">
                            <Text fontSize="xs" color="teal.700" fontWeight="700" w="100%">
                                {localSelected.length} selected
                            </Text>
                            {localSelected.map((p) => (
                                <Tag
                                    key={p.item_id}
                                    colorScheme="teal"
                                    borderRadius="full"
                                    size="sm">
                                    <TagLabel>{p.name ?? p.item_name}</TagLabel>
                                </Tag>
                            ))}
                        </Flex>
                    )}

                    {isLoading ? (
                        <Flex justify="center" py={12}>
                            <Spinner color={NAVY} size="lg" />
                        </Flex>
                    ) : items.length === 0 ? (
                        <Flex direction="column" align="center" py={12} color="gray.400">
                            <Text fontSize="3xl" mb={2}>
                                🔍
                            </Text>
                            <Text fontSize="sm">No products found</Text>
                        </Flex>
                    ) : (
                        <SimpleGrid columns={{ base: 1, md: 2 }} gap={3}>
                            {items.map((item) => {
                                const img = resolveImage(item);
                                const sel = isSelected(item);
                                return (
                                    <Box
                                        key={item.item_id}
                                        border="2px solid"
                                        borderColor={sel ? TEAL : BORDER}
                                        borderRadius="xl"
                                        p={3}
                                        cursor="pointer"
                                        bg={sel ? 'teal.50' : 'white'}
                                        _hover={{
                                            borderColor: TEAL,
                                            bg: 'teal.50',
                                            transform: 'translateY(-1px)',
                                        }}
                                        transition="all 0.15s"
                                        onClick={() => toggle(item)}>
                                        <Flex align="center" gap={3}>
                                            <Checkbox
                                                isChecked={sel}
                                                colorScheme="teal"
                                                onChange={() => toggle(item)}
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                            <Image
                                                src={img ?? p1}
                                                fallbackSrc={p1}
                                                w="48px"
                                                h="48px"
                                                objectFit="cover"
                                                borderRadius="lg"
                                                border={`1px solid ${BORDER}`}
                                                flexShrink={0}
                                            />
                                            <Box flex={1} minW={0}>
                                                <Text
                                                    fontSize="sm"
                                                    fontWeight="700"
                                                    noOfLines={1}
                                                    color={NAVY}>
                                                    {item.name ?? item.item_name}
                                                </Text>
                                                <Text
                                                    fontSize="11px"
                                                    color="gray.400"
                                                    fontFamily="mono">
                                                    {item.sku}
                                                </Text>
                                                {item.cf_item_price_unformatted && (
                                                    <Text
                                                        fontSize="xs"
                                                        color={TEAL}
                                                        fontWeight="700">
                                                        <WalletHistoryPrice
                                                            price={item.cf_item_price_unformatted}
                                                        />
                                                    </Text>
                                                )}
                                            </Box>
                                            {sel && (
                                                <CheckCircleIcon
                                                    color={TEAL}
                                                    boxSize={4}
                                                    flexShrink={0}
                                                />
                                            )}
                                        </Flex>
                                    </Box>
                                );
                            })}
                        </SimpleGrid>
                    )}

                    <Flex justify="space-between" align="center" mt={5}>
                        <Button
                            size="sm"
                            variant="outline"
                            isDisabled={page <= 1}
                            onClick={() => setPage((p) => p - 1)}
                            borderRadius="lg">
                            ← Prev
                        </Button>
                        <Text fontSize="xs" color="gray.400">
                            Page {page}
                        </Text>
                        <Button
                            size="sm"
                            variant="outline"
                            isDisabled={items.length < PER_PAGE}
                            onClick={() => setPage((p) => p + 1)}
                            borderRadius="lg">
                            Next →
                        </Button>
                    </Flex>
                </ModalBody>
                <Flex p={5} borderTop={`1px solid ${BORDER}`} gap={3} justify="flex-end">
                    <Button variant="outline" onClick={onClose} borderRadius="xl">
                        Cancel
                    </Button>
                    <Button
                        bg={NAVY}
                        color="white"
                        _hover={{ bg: NAVY2 }}
                        borderRadius="xl"
                        isDisabled={localSelected.length === 0}
                        onClick={() => {
                            onConfirm(localSelected);
                            onClose();
                        }}>
                        Continue with {localSelected.length} product
                        {localSelected.length !== 1 ? 's' : ''}
                    </Button>
                </Flex>
            </ModalContent>
        </Modal>
    );
};

// ── DispatchStep ───────────────────────────────────────────────────────────────
const DispatchStep = ({ deliveryAddress, cartItems, onConfirm, onBack }) => {
    const { routeMatch, isLoading: carriersLoading } = useGetQoutesAndCarriers();

    const [choice, setChoice] = useState(null);
    const [fetching, setFetching] = useState(false);
    const [fetchDone, setFetchDone] = useState(false);
    const [noCarriers, setNoCarriers] = useState(false);
    const [shipments, setShipments] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const normalizePickupAddr = (addr = {}) => ({
        line1: (addr.line1 || '').trim().toLowerCase(),
        city: (addr.city || '').trim().toLowerCase(),
        state: (addr.state || '').trim().toLowerCase(),
        country: (addr.country || '').trim().toUpperCase(),
    });

    const groupItems = (items = []) => {
        const groups = {};
        items.forEach((item) => {
            const countryCode =
                isoCountries.getAlpha2Code(item.cf_country, 'en') || item.cf_country || 'NG';
            const key = JSON.stringify(
                normalizePickupAddr({
                    line1: item.line_address,
                    city: item.cf_city,
                    state: item.cf_state,
                    country: countryCode,
                }),
            );
            const phone =
                formatPhoneNumberInternational(item?.phone, countryCode)?.split(' ').join('') || '';
            if (!groups[key]) {
                groups[key] = {
                    pickup_address: {
                        line1: item.line_address,
                        city: item.cf_city,
                        state: item.cf_state,
                        country: countryCode,
                        phone,
                    },
                    items: [],
                };
            }
            groups[key].items.push({
                name: item?.name,
                description: item?.description ?? item?.name,
                currency: 'NGN',
                value: item?.total_price ?? 0,
                weight: item?.cf_weight ?? 1,
                item_id: item?.item_id,
                quantity: item?.quantity ?? 1,
                pickup_address: groups[key].pickup_address,
            });
        });
        return Object.values(groups).flatMap((g) => g.items);
    };

    const formatStoreAddr = () => ({
        first_name: 'Obana',
        last_name: 'Africa',
        email: 'obana.africa@gmail.com',
        phone: STORE_OPEBI.address.phone,
        is_residential: false,
        line1: STORE_OPEBI.address.line1,
        city: STORE_OPEBI.address.city,
        state: STORE_OPEBI.address.state?.value,
        country: STORE_OPEBI.address.country?.label,
        zip: '100001',
    });

    const buildDeliveryAddr = () => {
        if (!deliveryAddress) return formatStoreAddr();
        const countryCode =
            typeof deliveryAddress.country === 'object'
                ? deliveryAddress.country?.value ?? deliveryAddress.country?.label
                : deliveryAddress.country;
        return {
            ...deliveryAddress,
            country: countryCode,
            phone:
                formatPhoneNumberInternational(deliveryAddress.phone, countryCode)
                    ?.split(' ')
                    .join('') || deliveryAddress.phone,
        };
    };

    const deliveryAddrLabel = (() => {
        if (!deliveryAddress) return 'Your delivery address';
        if (typeof deliveryAddress === 'string') return deliveryAddress;
        return (
            [
                deliveryAddress?.line1,
                deliveryAddress?.city,
                deliveryAddress?.state?.label ?? deliveryAddress?.state,
            ]
                .filter(Boolean)
                .join(', ') || 'Your delivery address'
        );
    })();

    const fetchShipments = async (type) => {
        setFetching(true);
        setFetchDone(false);
        setNoCarriers(false);
        setShipments([]);

        const isPickup = type === 'pickup';
        const delivAddr = isPickup ? formatStoreAddr() : buildDeliveryAddr();
        const FALLBACK = { line1: '77 opebi road', city: 'ikeja', state: 'lagos', country: 'NG' };

        const validatedItems = (cartItems || []).map((item) => ({
            ...item,
            line_address: item.line_address || FALLBACK.line1,
            cf_city: item.cf_city || FALLBACK.city,
            cf_state: item.cf_state || FALLBACK.state,
            cf_country: item.cf_country || FALLBACK.country,
        }));

        const payload = {
            delivery_address: delivAddr,
            currency: 'NGN',
            parcel: {
                description: 'obana logistics shipment',
                packaging: '',
                weight_unit: 'kg',
                items: groupItems(validatedItems),
            },
        };

        try {
            const result = await routeMatch(payload);
            const results = Array.isArray(result) ? result : result ? [result] : [];
            if (!results.length) setNoCarriers(true);
            else setShipments(results);
        } catch (err) {
            console.error('DispatchStep fetchShipments:', err);
            setNoCarriers(true);
        } finally {
            setFetching(false);
            setFetchDone(true);
        }
    };

    const handlePickup = () => {
        setChoice('pickup');
        onConfirm({
            carrier_id: STORE_OPEBI.carrier_id,
            carrier_name: STORE_OPEBI.name,
            amount: 0,
            delivery_time: STORE_OPEBI.delivery_time,
            carrier_rate_description: STORE_OPEBI.carrier_rate_description,
            dispatchType: 'pickup',
            delivery_type: 'pickup',
        });
    };

    const handleDoorDelivery = async () => {
        setChoice('delivery');
        setShowModal(true);
        await fetchShipments('delivery');
    };

    const totalAmount = shipments.reduce((s, sh) => s + (sh.amount || 0), 0);

    const handleConfirmDelivery = () => {
        onConfirm({
            carrier_id: 'obana_logistics',
            carrier_name: 'Obana Logistics',
            amount: totalAmount,
            delivery_time:
                shipments.length > 1
                    ? 'Multiple shipments'
                    : shipments[0]?.delivery_time || 'Obana Logistics delivery',
            carrier_rate_description:
                shipments.length > 1
                    ? `${shipments.length} grouped shipments`
                    : shipments[0]?.carrier_rate_description || 'Obana Logistics delivery',
            shipments,
            dispatchType: 'delivery',
            delivery_type: shipments.length > 1 ? 'multi-shipment' : 'single-shipment',
            isMultiVendor: shipments.length > 1,
        });
        setShowModal(false);
    };

    return (
        <Box>
            <Text
                fontWeight="700"
                color={NAVY}
                fontSize="sm"
                textTransform="uppercase"
                letterSpacing="0.06em"
                mb={4}>
                Choose Delivery Method
            </Text>

            <VStack spacing={3} mb={6} align="stretch">
                {/* Pickup */}
                <Box
                    border="2px solid"
                    borderColor={choice === 'pickup' ? NAVY : BORDER}
                    borderRadius="xl"
                    p={4}
                    cursor="pointer"
                    bg={choice === 'pickup' ? '#EEF3F9' : 'white'}
                    _hover={{ borderColor: NAVY, bg: '#EEF3F9' }}
                    transition="all 0.15s"
                    onClick={handlePickup}>
                    <HStack spacing={4} align="start">
                        <Text fontSize="xl" flexShrink={0}>
                            🏢
                        </Text>
                        <Box flex={1}>
                            <Text fontWeight="700" fontSize="sm" color={NAVY}>
                                Fulfilment Centre Pickup
                            </Text>
                            <Text fontSize="xs" color="gray.500" mt="2px">
                                {STORE_OPEBI.address.line1}, {STORE_OPEBI.address.city},{' '}
                                {STORE_OPEBI.address.state?.label}
                            </Text>
                            <Text fontSize="xs" color={TEAL} fontWeight="600" mt="2px">
                                Free · Same-day collection
                            </Text>
                        </Box>
                        {choice === 'pickup' && (
                            <CheckCircleIcon color={NAVY} boxSize={5} flexShrink={0} />
                        )}
                    </HStack>
                </Box>

                {/* Door delivery */}
                <Box
                    border="2px solid"
                    borderColor={choice === 'delivery' ? NAVY : BORDER}
                    borderRadius="xl"
                    p={4}
                    cursor="pointer"
                    bg={choice === 'delivery' ? '#EEF3F9' : 'white'}
                    _hover={{ borderColor: NAVY, bg: '#EEF3F9' }}
                    transition="all 0.15s"
                    onClick={handleDoorDelivery}>
                    <HStack spacing={4} align="start">
                        <Text fontSize="xl" flexShrink={0}>
                            🚚
                        </Text>
                        <Box flex={1}>
                            <Text fontWeight="700" fontSize="sm" color={NAVY}>
                                Door Delivery
                            </Text>
                            <Text fontSize="xs" color="gray.500" mt="2px" noOfLines={2}>
                                {deliveryAddrLabel}
                            </Text>
                            <Text fontSize="xs" color="gray.400" mt="2px">
                                Via Obana Logistics
                            </Text>
                        </Box>
                        {choice === 'delivery' && (
                            <CheckCircleIcon color={NAVY} boxSize={5} flexShrink={0} />
                        )}
                    </HStack>
                </Box>
            </VStack>

            <Button variant="outline" borderRadius="xl" onClick={onBack}>
                ← Back
            </Button>

            {/* Shipment detail modal */}
            <Modal
                isOpen={showModal}
                onClose={() => {
                    setShowModal(false);
                    setChoice(null);
                }}
                size={{ base: 'full', md: 'lg' }}
                isCentered
                scrollBehavior="inside">
                <ModalOverlay bg="blackAlpha.500" backdropFilter="blur(4px)" />
                <ModalContent
                    borderRadius={{ base: '2xl 2xl 0 0', md: '2xl' }}
                    border={`1px solid ${BORDER}`}
                    shadow="2xl"
                    maxH={{ base: '92vh', md: '85vh' }}
                    mx={{ base: 0, md: 'auto' }}
                    mb={{ base: 0, md: 'auto' }}
                    mt={{ base: 'auto', md: 'auto' }}
                    position={{ base: 'fixed', md: 'relative' }}
                    bottom={{ base: 0, md: 'auto' }}
                    w={{ base: '100%', md: 'auto' }}>
                    <ModalHeader bg={NAVY} color="white" borderTopRadius="2xl" py={5} px={5}>
                        <Text fontSize="md" fontWeight="800">
                            {fetchDone && !noCarriers
                                ? 'Obana Logistics Shipment Summary'
                                : 'Calculating Rates…'}
                        </Text>
                        <Text fontSize="xs" opacity={0.65} mt="2px" fontWeight="400">
                            {fetchDone && !noCarriers
                                ? 'Review your shipment details and confirm'
                                : 'Please wait while we calculate your delivery rates'}
                        </Text>
                    </ModalHeader>
                    <ModalCloseButton color="white" top={4} />

                    <ModalBody px={{ base: 4, md: 6 }} py={5} overflowY="auto">
                        {fetching || carriersLoading ? (
                            <Center py={12} flexDirection="column" gap={3}>
                                <Spinner size="lg" color={NAVY} thickness="3px" />
                                <Text fontSize="sm" color="gray.500" textAlign="center">
                                    Fetching Obana Logistics shipment details…
                                </Text>
                            </Center>
                        ) : noCarriers ? (
                            <Center py={12}>
                                <VStack spacing={4} maxW="400px" textAlign="center">
                                    <Text fontSize="3xl">😕</Text>
                                    <Text fontWeight="700" color={NAVY}>
                                        No Carriers Available
                                    </Text>
                                    <Text fontSize="sm" color="gray.500">
                                        Please verify your delivery address and try again.
                                    </Text>
                                    <Button
                                        variant="outline"
                                        borderRadius="xl"
                                        size="sm"
                                        onClick={() => {
                                            setShowModal(false);
                                            setChoice(null);
                                        }}>
                                        Go Back
                                    </Button>
                                </VStack>
                            </Center>
                        ) : (
                            <VStack spacing={4} align="stretch">
                                <Box
                                    bg="#EEF3F9"
                                    borderRadius="xl"
                                    p={4}
                                    border={`1px solid ${BORDER}`}>
                                    <Flex justify="space-between" align="center">
                                        <Box>
                                            <Text fontWeight="700" fontSize="sm" color={NAVY}>
                                                Total Delivery Cost
                                            </Text>
                                            <Text fontSize="xs" color="gray.500" mt="2px">
                                                {shipments.length > 1
                                                    ? `${shipments.length} grouped shipments will be dispatched`
                                                    : 'A single shipment will be dispatched'}
                                            </Text>
                                        </Box>
                                        <Text fontWeight="800" fontSize="xl" color={NAVY}>
                                            ₦{totalAmount.toLocaleString()}
                                        </Text>
                                    </Flex>
                                </Box>

                                {shipments.map((shipment, idx) => (
                                    <Box
                                        key={shipment.id || idx}
                                        bg="white"
                                        p={4}
                                        border={`1px solid ${BORDER}`}
                                        borderRadius="xl">
                                        <Flex justify="space-between" align="center" mb={2}>
                                            <Text fontWeight="700" fontSize="sm" color={NAVY}>
                                                Shipment {idx + 1}
                                            </Text>
                                            <Text fontWeight="700" fontSize="sm" color={TEAL}>
                                                ₦{(shipment.amount || 0).toLocaleString()}
                                            </Text>
                                        </Flex>
                                        <VStack align="start" spacing={1}>
                                            {(shipment.pickup_address?.line1 ||
                                                shipment.pickup_address?.city) && (
                                                <Text fontSize="xs" color="gray.500">
                                                    Pickup:{' '}
                                                    {[
                                                        shipment.pickup_address?.line1,
                                                        shipment.pickup_address?.city,
                                                    ]
                                                        .filter(Boolean)
                                                        .join(', ')}
                                                </Text>
                                            )}
                                            <Text fontSize="xs" color="gray.500">
                                                Items: {shipment.items?.length || 0}
                                            </Text>
                                            {shipment.delivery_time && (
                                                <Text fontSize="xs" color="gray.500">
                                                    Est. delivery: {shipment.delivery_time}
                                                </Text>
                                            )}
                                            {shipment.carrier_name && (
                                                <Text fontSize="xs" color="gray.500">
                                                    Carrier: {shipment.carrier_name}
                                                </Text>
                                            )}
                                        </VStack>
                                    </Box>
                                ))}
                            </VStack>
                        )}
                    </ModalBody>

                    <Flex p={5} borderTop={`1px solid ${BORDER}`} gap={3}>
                        <Button
                            flex={1}
                            variant="outline"
                            borderRadius="xl"
                            onClick={() => {
                                setShowModal(false);
                                setChoice(null);
                            }}>
                            Cancel
                        </Button>
                        <Button
                            flex={1}
                            bg={NAVY}
                            color="white"
                            _hover={{ bg: NAVY2 }}
                            borderRadius="xl"
                            isDisabled={!fetchDone || noCarriers || !shipments.length}
                            onClick={handleConfirmDelivery}>
                            Confirm & Continue →
                        </Button>
                    </Flex>
                </ModalContent>
            </Modal>
        </Box>
    );
};

const RequestFormView = ({
    selectedProduct,
    setSelectedProduct,
    onCancel,
    onSuccess,
    flattenedUser,
    customerContext,
}) => {
    const selectedCurrency = useSelector((s) => s.currencyReducer.currenciesRates);
    const { mutate, isPending } = useSampleRequestMutations();
    const usdToNairaPrice = useUSDToNairaCurrency(
        selectedProduct?.reduce((s, p) => s + (p.cf_item_price_unformatted ?? 0), 0),
    );
    const userAttrs = flattenedUser?.attributes || {};

    const [isPickerOpen, setIsPickerOpen] = useState(false);
    const [step, setStep] = useState(1);
    const [dispatcher, setDispatcher] = useState(null);

    const [selectedOption, setSelectedOption] = useState('');

    const deliveryAddress = (() => {
        const ctxAddr = customerContext?.delivery_address ?? {};
        const hasCtxAddr = ctxAddr.line1 || ctxAddr.city;
        if (hasCtxAddr) return ctxAddr;
        return {
            first_name: userAttrs?.first_name ?? '',
            last_name: userAttrs?.last_name ?? '',
            email: flattenedUser?.email || '',
            phone: flattenedUser?.phone || '',
            line1: userAttrs?.address || '',
            city: userAttrs?.city || '',
            state: userAttrs?.state || '',
            country: userAttrs?.country || '',
            is_residential: true,
        };
    })();

    const totalPrice = selectedProduct.reduce(
        (sum, p) => sum + (p.cf_item_price_unformatted ?? 0),
        0,
    );
    const convertedPrice = totalPrice / (selectedCurrency?.sell ?? 1);
    const currencySymbol = selectedCurrency?.symbol || '₦';

    const [formData, setFormData] = useState({ reason: {}, quantity: {}, size: {}, color: {} });
    const setNested = (key, id, val) =>
        setFormData((prev) => ({ ...prev, [key]: { ...(prev[key] || {}), [id]: val } }));

    const cartItemsForDispatch = selectedProduct.map((item) => ({
        name: item.name ?? item.item_name,
        description: item.name ?? item.item_name,
        total_price: item.cf_item_price_unformatted ?? 0,
        cf_weight: item.cf_weight ?? 1,
        item_id: item.item_id,
        quantity: formData.quantity?.[item.item_id] ?? 1,
        line_address:
            item.cf_vendor_address ?? item.custom_field_hash?.cf_vendor_address ?? '77 opebi road',
        cf_city: item.cf_vendor_city ?? item.custom_field_hash?.cf_vendor_city ?? 'ikeja',
        cf_state: item.cf_vendor_state ?? item.custom_field_hash?.cf_vendor_state ?? 'lagos',
        cf_country: item.cf_vendor_country ?? item.custom_field_hash?.cf_vendor_country ?? 'NG',
    }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (selectedProduct.length === 0) {
            toast.error('Please select at least one product');
            return;
        }
        if (!selectedOption) {
            toast.error('Please choose a payment option');
            return;
        }

        try {
            const payload = {
                products: selectedProduct.map((item) => ({
                    item_id: item.item_id,
                    qty: formData.quantity?.[item.item_id] ?? 1,
                    reason: formData.reason?.[item.item_id] ?? '',
                    color: formData.color?.[item.item_id] || item.color || item.cf_color || '',
                    size: formData.size?.[item.item_id] || item.size || item.cf_sizes_run || '',
                    product_name: item.name ?? item.item_name ?? item.item_id,
                    product_image: resolveImage(item) ?? '',
                    vendor_id: item.cf_vendor_id ?? item.custom_field_hash?.cf_vendor_id ?? null,
                    vendor_name:
                        item.cf_vendor_name ?? item.custom_field_hash?.cf_vendor_name ?? null,
                    sku: item.sku ?? null,
                    rate: item.rate ?? item.cf_item_price_unformatted ?? 0,
                    unit: item.unit ?? null,
                    brand: item.brand ?? null,
                    category_id: item.category_id ?? null,
                    category_name: item.category_name ?? null,
                    is_grouped: item.is_grouped ?? false,
                    group_id: item.group_id ?? null,
                    group_name: item.group_name ?? null,
                    cf_singleimage:
                        item.cf_singleimage ?? item.custom_field_hash?.cf_singleimage ?? null,
                    cf_productimages:
                        item.cf_productimages ?? item.custom_field_hash?.cf_productimages ?? null,
                })),
                customer_id: customerContext?.customer_id ?? userAttrs?.zoho_id,
                delivery_address: {
                    first_name:
                        deliveryAddress.first_name ?? deliveryAddress.line1?.split(' ')?.[0] ?? '',
                    last_name: deliveryAddress.last_name ?? '',
                    email: deliveryAddress.email,
                    phone: deliveryAddress.phone,
                    is_residential: true,
                    line1: deliveryAddress.line1,
                    city: deliveryAddress.city,
                    state:
                        typeof deliveryAddress.state === 'object'
                            ? deliveryAddress.state?.value
                            : deliveryAddress.state,
                    country:
                        typeof deliveryAddress.country === 'object'
                            ? deliveryAddress.country?.value
                            : deliveryAddress.country,
                    metadata: {
                        customerId: customerContext?.customer_id ?? userAttrs?.zoho_id,
                        currency: {
                            symbol: selectedCurrency?.symbol,
                            rate: selectedCurrency?.sell,
                        },
                        customerName: `${deliveryAddress.first_name ?? ''} ${
                            deliveryAddress.last_name ?? ''
                        }`.trim(),
                        line1: deliveryAddress.line1,
                        city: deliveryAddress.city,
                        state:
                            typeof deliveryAddress.state === 'object'
                                ? deliveryAddress.state?.label
                                : deliveryAddress.state,
                        country:
                            typeof deliveryAddress.country === 'object'
                                ? deliveryAddress.country?.label
                                : deliveryAddress.country,
                        line_items: selectedProduct.map((item) => ({
                            item_id: item.item_id,
                            product_name: item.name ?? item.item_name ?? '',
                            product_image: resolveImage(item) ?? '',
                            vendor_id: item.cf_vendor_id ?? null,
                            vendor_name: item.cf_vendor_name ?? null,
                            quantity: formData.quantity?.[item.item_id] ?? 1,
                            color:
                                formData.color?.[item.item_id] || item.color || item.cf_color || '',
                            size:
                                formData.size?.[item.item_id] ||
                                item.size ||
                                item.cf_sizes_run ||
                                '',
                            reason: formData.reason?.[item.item_id] ?? '',
                            sku: item.sku ?? '',
                            rate: item.rate ?? item.cf_item_price_unformatted ?? 0,
                        })),
                    },
                },
                dispatcher,
                currency: { symbol: selectedCurrency?.symbol, rate: selectedCurrency?.sell },
                amount: convertedPrice,
                carrier_id: dispatcher?.carrier_id ?? 'CA-EMBFYYC4LO4IHFTW',
                payment_method: selectedOption,
            };

            const response = await mutate(payload);
            if (!response?.success) throw new Error(response?.message ?? 'Request failed');

            if (selectedOption === 'PAYSTACK') {
                const popup = new Paystack();
                popup.checkout({
                    key: process.env.REACT_APP_PAYSTACK_KEY,
                    email: flattenedUser?.email,
                    currency: usdToNairaPrice?.symbol,
                    amount: Math.round((usdToNairaPrice?.price ?? 0) * 100),
                    paymentMethods: ['card'],
                    reference: response?.order_ref,
                    metadata: { orderRef: response?.order_ref },
                    onSuccess: () => {
                        toast.success('Payment successful!');
                        onSuccess();
                    },
                    onCancel: () => toast.error('Payment cancelled'),
                    onError: (err) => toast.error(err.message),
                });
            } else {
                toast.success('Sample request submitted!');
                onSuccess();
            }
        } catch (err) {
            console.error(err);
            toast.error(err?.message ?? 'Failed to submit sample request.');
        }
    };

    const StepDot = ({ n, label }) => (
        <Flex align="center" gap={2}>
            <Flex
                w="26px"
                h="26px"
                borderRadius="full"
                align="center"
                justify="center"
                bg={step >= n ? NAVY : 'gray.200'}
                color={step >= n ? 'white' : 'gray.500'}
                fontSize="xs"
                fontWeight="700"
                transition="all 0.2s"
                flexShrink={0}>
                {step > n ? '✓' : n}
            </Flex>
            <Text
                fontSize={{ base: '10px', md: 'xs' }}
                fontWeight={step === n ? '700' : '400'}
                color={step === n ? NAVY : 'gray.400'}
                whiteSpace="nowrap">
                {label}
            </Text>
        </Flex>
    );
    const Connector = ({ active }) => (
        <Box flex={1} h="1px" bg={active ? NAVY : BORDER} transition="all 0.3s" maxW="48px" />
    );

    return (
        <Box>
            <Flex align="center" justify="space-between" mb={5} px={1}>
                <Box>
                    <Text
                        fontWeight="800"
                        fontSize={{ base: 'lg', md: 'xl' }}
                        color={NAVY}
                        letterSpacing="-0.02em">
                        New Sample Request
                    </Text>
                    <Text fontSize="sm" color="gray.500" mt="2px">
                        Fill out the details below to submit your request
                    </Text>
                </Box>
                <Button size="sm" variant="ghost" colorScheme="red" onClick={onCancel}>
                    ✕ Cancel
                </Button>
            </Flex>

            {/* Step indicator */}
            <Flex gap={2} mb={7} align="center" px={1} overflowX="auto">
                <StepDot n={1} label="Products" />
                <Connector active={step >= 2} />
                <StepDot n={2} label="Delivery" />
                <Connector active={step >= 3} />
                <StepDot n={3} label="Payment" />
            </Flex>

            {/* ══ STEP 1 — Products ══ */}
            {step === 1 && (
                <Box>
                    {customerContext?.customer && (
                        <Flex
                            align="center"
                            gap={2}
                            mb={4}
                            p={3}
                            bg="#EEF3F9"
                            borderRadius="xl"
                            border={`1px solid ${BORDER}`}>
                            <Text fontSize="xs" color={NAVY} fontWeight="700">
                                👤 Customer:
                            </Text>
                            <Text fontSize="xs" color="gray.600" noOfLines={1}>
                                {customerContext.customer.first_name}{' '}
                                {customerContext.customer.last_name}
                                {customerContext.customer.email
                                    ? ` · ${customerContext.customer.email}`
                                    : ''}
                            </Text>
                        </Flex>
                    )}

                    <Flex align="center" justify="space-between" mb={4}>
                        <Text
                            fontWeight="700"
                            color={NAVY}
                            fontSize="sm"
                            textTransform="uppercase"
                            letterSpacing="0.06em">
                            Selected Products ({selectedProduct.length})
                        </Text>
                        <Button
                            size="sm"
                            variant="outline"
                            colorScheme="teal"
                            borderRadius="xl"
                            onClick={() => setIsPickerOpen(true)}>
                            + Add / Change
                        </Button>
                    </Flex>

                    {selectedProduct.length === 0 ? (
                        <Flex
                            direction="column"
                            align="center"
                            justify="center"
                            minH="120px"
                            borderRadius="2xl"
                            border="2px dashed"
                            borderColor={BORDER}
                            bg={SLATE}
                            mb={6}
                            cursor="pointer"
                            onClick={() => setIsPickerOpen(true)}
                            _hover={{ borderColor: TEAL, bg: 'teal.50' }}
                            transition="all 0.2s">
                            <Text fontSize="2xl" mb={2}>
                                📦
                            </Text>
                            <Text fontSize="sm" color="gray.500" fontWeight="600">
                                Click to select products
                            </Text>
                        </Flex>
                    ) : (
                        <VStack spacing={3} mb={6} align="stretch">
                            {selectedProduct.map((item) => (
                                <Box
                                    key={item.item_id}
                                    bg="white"
                                    borderRadius="2xl"
                                    border={`1px solid ${BORDER}`}
                                    overflow="hidden"
                                    shadow="sm">
                                    <Flex
                                        align="center"
                                        gap={3}
                                        p={3}
                                        bg={SLATE}
                                        borderBottom={`1px solid ${BORDER}`}>
                                        <Image
                                            src={resolveImage(item) ?? p1}
                                            fallbackSrc={p1}
                                            h="48px"
                                            w="48px"
                                            objectFit="cover"
                                            borderRadius="xl"
                                            border={`2px solid ${BORDER}`}
                                            flexShrink={0}
                                        />
                                        <Box flex={1} minW={0}>
                                            <Text
                                                fontWeight="700"
                                                fontSize="sm"
                                                color={NAVY}
                                                noOfLines={1}>
                                                {item.name ?? item.item_name}
                                            </Text>
                                            <Text fontSize="xs" color="gray.400" fontFamily="mono">
                                                {item.sku}
                                            </Text>
                                            <Text
                                                fontSize="xs"
                                                color={TEAL}
                                                fontWeight="700"
                                                mt="2px">
                                                <WalletHistoryPrice
                                                    price={item.cf_item_price_unformatted}
                                                />{' '}
                                                / unit
                                            </Text>
                                        </Box>
                                        <Button
                                            size="xs"
                                            variant="ghost"
                                            colorScheme="red"
                                            borderRadius="lg"
                                            onClick={() =>
                                                setSelectedProduct((prev) =>
                                                    prev.filter((p) => p.item_id !== item.item_id),
                                                )
                                            }>
                                            Remove
                                        </Button>
                                    </Flex>
                                    <Box p={3}>
                                        <Flex gap={3} flexWrap="wrap" mb={3}>
                                            <Box minW="80px">
                                                <Text
                                                    fontSize="xs"
                                                    fontWeight="700"
                                                    color="gray.600"
                                                    mb={1}
                                                    textTransform="uppercase"
                                                    letterSpacing="0.04em">
                                                    Qty
                                                </Text>
                                                <Input
                                                    type="number"
                                                    min={1}
                                                    size="sm"
                                                    borderRadius="lg"
                                                    disabled
                                                    bg={SLATE}
                                                    border={`1px solid ${BORDER}`}
                                                    value={formData.quantity?.[item.item_id] ?? 1}
                                                    _focus={{ borderColor: TEAL }}
                                                    onChange={(e) =>
                                                        setNested(
                                                            'quantity',
                                                            item.item_id,
                                                            parseInt(e.target.value) || 1,
                                                        )
                                                    }
                                                />
                                            </Box>
                                            {item.cf_sizes_run_unformatted && (
                                                <Box minW="110px">
                                                    <Text
                                                        fontSize="xs"
                                                        fontWeight="700"
                                                        color="gray.600"
                                                        mb={1}
                                                        textTransform="uppercase"
                                                        letterSpacing="0.04em">
                                                        Size
                                                    </Text>
                                                    <Select
                                                        size="sm"
                                                        borderRadius="lg"
                                                        bg={SLATE}
                                                        border={`1px solid ${BORDER}`}
                                                        placeholder="Choose size"
                                                        _focus={{ borderColor: TEAL }}
                                                        value={formData.size?.[item.item_id] ?? ''}
                                                        onChange={(e) =>
                                                            setNested(
                                                                'size',
                                                                item.item_id,
                                                                e.target.value,
                                                            )
                                                        }>
                                                        {item.cf_sizes_run_unformatted
                                                            .split(',')
                                                            .map((s) => (
                                                                <option
                                                                    key={s.trim()}
                                                                    value={s.trim()}>
                                                                    {s.trim()}
                                                                </option>
                                                            ))}
                                                    </Select>
                                                </Box>
                                            )}
                                            {item.cf_color_unformatted && (
                                                <Box minW="110px">
                                                    <Text
                                                        fontSize="xs"
                                                        fontWeight="700"
                                                        color="gray.600"
                                                        mb={1}
                                                        textTransform="uppercase"
                                                        letterSpacing="0.04em">
                                                        Colour
                                                    </Text>
                                                    <Select
                                                        size="sm"
                                                        borderRadius="lg"
                                                        bg={SLATE}
                                                        border={`1px solid ${BORDER}`}
                                                        placeholder="Choose colour"
                                                        _focus={{ borderColor: TEAL }}
                                                        value={formData.color?.[item.item_id] ?? ''}
                                                        onChange={(e) =>
                                                            setNested(
                                                                'color',
                                                                item.item_id,
                                                                e.target.value,
                                                            )
                                                        }>
                                                        {item.cf_color_unformatted
                                                            .split(',')
                                                            .map((c) => (
                                                                <option
                                                                    key={c.trim()}
                                                                    value={c.trim()}>
                                                                    {c.trim()}
                                                                </option>
                                                            ))}
                                                    </Select>
                                                </Box>
                                            )}
                                        </Flex>
                                        <Box>
                                            <Text
                                                fontSize="xs"
                                                fontWeight="700"
                                                color="gray.600"
                                                mb={1}
                                                textTransform="uppercase"
                                                letterSpacing="0.04em">
                                                Reason *
                                            </Text>
                                            <Textarea
                                                size="sm"
                                                borderRadius="lg"
                                                bg={SLATE}
                                                border={`1px solid ${BORDER}`}
                                                minH="60px"
                                                placeholder="e.g., I'm interested in ordering 100 units"
                                                _focus={{ borderColor: TEAL }}
                                                value={formData.reason?.[item.item_id] ?? ''}
                                                onChange={(e) =>
                                                    setNested(
                                                        'reason',
                                                        item.item_id,
                                                        e.target.value,
                                                    )
                                                }
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            ))}
                        </VStack>
                    )}

                    {selectedProduct.length > 0 && (
                        <Box bg={NAVY} borderRadius="2xl" p={4} mb={6} color="white">
                            <Flex justify="space-between" align="center">
                                <Box>
                                    <Text fontSize="xs" opacity={0.65} mb="1px">
                                        Estimated Total
                                    </Text>
                                    <Text fontWeight="800" fontSize="lg">
                                        {currencySymbol}
                                        {convertedPrice.toLocaleString(undefined, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Text>
                                </Box>
                                <Text fontSize="xs" opacity={0.5}>
                                    {selectedProduct.length} product
                                    {selectedProduct.length !== 1 ? 's' : ''}
                                </Text>
                            </Flex>
                        </Box>
                    )}

                    <Flex justify="flex-end">
                        <Button
                            bg={NAVY}
                            color="white"
                            _hover={{ bg: NAVY2 }}
                            borderRadius="xl"
                            px={8}
                            isDisabled={selectedProduct.length === 0}
                            onClick={() => setStep(2)}>
                            Next: Choose Delivery →
                        </Button>
                    </Flex>
                </Box>
            )}

            {/* ══ STEP 2 — Delivery ══ */}
            {step === 2 && (
                <DispatchStep
                    deliveryAddress={deliveryAddress}
                    cartItems={cartItemsForDispatch}
                    onConfirm={(disp) => {
                        setDispatcher(disp);
                        setStep(3);
                    }}
                    onBack={() => setStep(1)}
                />
            )}

            {/* ══ STEP 3 — Payment (address already confirmed) ══ */}
            {step === 3 && (
                <Box>
                    {/* Dispatcher summary */}
                    {dispatcher && (
                        <Flex
                            align="center"
                            gap={3}
                            mb={5}
                            p={3}
                            bg="#EEF3F9"
                            borderRadius="xl"
                            border={`1px solid ${BORDER}`}>
                            <Text fontSize="xl">
                                {dispatcher.dispatchType === 'pickup' ? '🏢' : '🚚'}
                            </Text>
                            <Box flex={1}>
                                <Text fontSize="xs" fontWeight="700" color={NAVY}>
                                    {dispatcher.carrier_name}
                                </Text>
                                <Text fontSize="xs" color="gray.500">
                                    {dispatcher.carrier_rate_description}
                                </Text>
                            </Box>
                            <Box textAlign="right">
                                <Text fontSize="xs" color="gray.400">
                                    Delivery fee
                                </Text>
                                <Text fontSize="sm" fontWeight="700" color={NAVY}>
                                    {dispatcher.amount > 0
                                        ? `₦${dispatcher.amount.toLocaleString()}`
                                        : 'Free'}
                                </Text>
                            </Box>
                            <Button
                                size="xs"
                                variant="ghost"
                                colorScheme="blue"
                                onClick={() => setStep(2)}>
                                Change
                            </Button>
                        </Flex>
                    )}

                    {/* Delivery address summary (read-only) */}
                    {(deliveryAddress?.line1 || deliveryAddress?.city) && (
                        <Box
                            mb={5}
                            p={4}
                            bg={SLATE}
                            borderRadius="xl"
                            border={`1px solid ${BORDER}`}>
                            <Text
                                fontSize="10px"
                                color="gray.400"
                                fontWeight="700"
                                textTransform="uppercase"
                                letterSpacing="0.06em"
                                mb={2}>
                                Delivering to
                            </Text>
                            <Text fontSize="sm" fontWeight="700" color={NAVY}>
                                {`${deliveryAddress.first_name ?? ''} ${
                                    deliveryAddress.last_name ?? ''
                                }`.trim() || 'Customer'}
                            </Text>
                            <Text fontSize="xs" color="gray.500" mt={1}>
                                {[
                                    deliveryAddress.line1,
                                    deliveryAddress.city,
                                    typeof deliveryAddress.state === 'object'
                                        ? deliveryAddress.state?.label
                                        : deliveryAddress.state,
                                    typeof deliveryAddress.country === 'object'
                                        ? deliveryAddress.country?.label
                                        : deliveryAddress.country,
                                ]
                                    .filter(Boolean)
                                    .join(', ')}
                            </Text>
                            {deliveryAddress.phone && (
                                <Text fontSize="xs" color="gray.500">
                                    {deliveryAddress.phone}
                                </Text>
                            )}
                            {deliveryAddress.email && (
                                <Text fontSize="xs" color="gray.500">
                                    {deliveryAddress.email}
                                </Text>
                            )}
                        </Box>
                    )}

                    <Divider borderColor={BORDER} my={5} />

                    <Text
                        fontWeight="700"
                        color={NAVY}
                        fontSize="sm"
                        textTransform="uppercase"
                        letterSpacing="0.06em"
                        mb={4}>
                        Payment Option
                    </Text>

                    <RadioGroup value={selectedOption} onChange={setSelectedOption} mb={6}>
                        <VStack align="stretch" spacing={3}>
                            {[
                                {
                                    val: 'POD',
                                    icon: '💵',
                                    title: 'Pay on Delivery / Pickup',
                                    sub: 'Pay when your order arrives',
                                },
                                {
                                    val: 'PAYSTACK',
                                    icon: '💳',
                                    title: 'Pay with Paystack',
                                    sub: 'Card or bank account',
                                },
                                {
                                    val: 'WALLET',
                                    icon: '👛',
                                    title: 'Pay with Wallet',
                                    sub: 'Use your wallet balance',
                                },
                            ].map((opt) => {
                                const active = selectedOption === opt.val;
                                return (
                                    <Box
                                        key={opt.val}
                                        border="2px solid"
                                        borderColor={active ? NAVY : BORDER}
                                        p={4}
                                        borderRadius="xl"
                                        cursor="pointer"
                                        bg={active ? '#EEF3F9' : 'white'}
                                        _hover={{ borderColor: NAVY, bg: '#EEF3F9' }}
                                        transition="all 0.15s"
                                        onClick={() => setSelectedOption(opt.val)}>
                                        <HStack spacing={4}>
                                            <Text fontSize="xl">{opt.icon}</Text>
                                            <Radio value={opt.val} colorScheme="blue" />
                                            <Box flex={1}>
                                                <Text
                                                    fontWeight="700"
                                                    fontSize="sm"
                                                    color={active ? NAVY : 'gray.700'}>
                                                    {opt.title}
                                                </Text>
                                                <Text fontSize="xs" color="gray.400">
                                                    {opt.sub}
                                                </Text>
                                            </Box>
                                            {active && <CheckCircleIcon color={NAVY} />}
                                        </HStack>
                                    </Box>
                                );
                            })}
                        </VStack>
                    </RadioGroup>

                    <Flex justify="space-between" gap={3}>
                        <Button variant="outline" borderRadius="xl" onClick={() => setStep(2)}>
                            ← Back
                        </Button>
                        <Button
                            bg={NAVY}
                            color="white"
                            _hover={{ bg: NAVY2 }}
                            borderRadius="xl"
                            px={8}
                            isLoading={isPending}
                            isDisabled={isPending || selectedProduct.length === 0}
                            onClick={handleSubmit}>
                            Submit Request
                        </Button>
                    </Flex>
                </Box>
            )}

            <ProductPickerModal
                isOpen={isPickerOpen}
                onClose={() => setIsPickerOpen(false)}
                selectedProducts={selectedProduct}
                onConfirm={setSelectedProduct}
            />
        </Box>
    );
};

// ── RequestDetailRow ───────────────────────────────────────────────────────────
const RequestDetailRow = ({ quote }) => {
    const addr = parseDeliveryAddress(quote.delivery_address);
    const details = parseSampleDetails(quote.sample_details);
    const lineItems = details?.line_items ?? addr?.metadata?.line_items ?? [];

    const addrStr = [
        addr.line1,
        addr.city,
        typeof addr.state === 'object' ? addr.state?.label : addr.state,
        typeof addr.country === 'object' ? addr.country?.label : addr.country,
    ]
        .filter(Boolean)
        .join(', ');

    return (
        <Box p={{ base: 4, md: 5 }} bg={SLATE} borderTop={`1px solid ${BORDER}`}>
            <SimpleGrid columns={{ base: 1, md: 3 }} gap={4} mb={4}>
                {[
                    { label: 'Order Reference', value: quote.order_ref, mono: true },
                    { label: 'Contact Person', value: quote.name || '—' },
                    { label: 'Phone', value: quote.phone || '—' },
                    { label: 'Email', value: quote.email || '—' },
                    { label: 'Delivery Address', value: addrStr || '—' },
                    { label: 'Payment', value: quote.payment_method || 'POD' },
                ].map(({ label, value, mono }) => (
                    <Box
                        key={label}
                        bg="white"
                        borderRadius="xl"
                        p={3}
                        border={`1px solid ${BORDER}`}>
                        <Text
                            fontSize="10px"
                            color="gray.400"
                            fontWeight="700"
                            textTransform="uppercase"
                            letterSpacing="0.06em"
                            mb={1}>
                            {label}
                        </Text>
                        <Text
                            fontSize="sm"
                            fontWeight="600"
                            color={NAVY}
                            fontFamily={mono ? 'mono' : 'inherit'}
                            wordBreak="break-all">
                            {value}
                        </Text>
                    </Box>
                ))}
            </SimpleGrid>

            {lineItems.length > 0 && (
                <Box>
                    <Text
                        fontSize="10px"
                        fontWeight="700"
                        color="gray.400"
                        textTransform="uppercase"
                        letterSpacing="0.06em"
                        mb={3}>
                        Requested Items ({lineItems.length})
                    </Text>
                    <VStack align="stretch" spacing={2}>
                        {lineItems.map((li, idx) => (
                            <Flex
                                key={idx}
                                align="center"
                                gap={3}
                                bg="white"
                                p={3}
                                borderRadius="xl"
                                border={`1px solid ${BORDER}`}>
                                <Flex
                                    w="30px"
                                    h="30px"
                                    borderRadius="lg"
                                    bg={NAVY}
                                    align="center"
                                    justify="center"
                                    flexShrink={0}>
                                    <Text color="white" fontSize="xs" fontWeight="700">
                                        {idx + 1}
                                    </Text>
                                </Flex>
                                <Box flex={1}>
                                    <Text fontSize="xs" fontWeight="700" color={NAVY}>
                                        {li.product_name ?? li.item_id}
                                    </Text>
                                    <Flex gap={3} mt="2px" flexWrap="wrap">
                                        <Text fontSize="xs" color="gray.500">
                                            Qty: <b>{li.quantity ?? 1}</b>
                                        </Text>
                                        {li.size && (
                                            <Text fontSize="xs" color="gray.500">
                                                Size: <b>{li.size}</b>
                                            </Text>
                                        )}
                                        {li.color && (
                                            <Text fontSize="xs" color="gray.500">
                                                Color: <b>{li.color}</b>
                                            </Text>
                                        )}
                                    </Flex>
                                    {li.reason && (
                                        <Text
                                            fontSize="xs"
                                            color="gray.400"
                                            mt={1}
                                            fontStyle="italic">
                                            "{li.reason}"
                                        </Text>
                                    )}
                                </Box>
                            </Flex>
                        ))}
                    </VStack>
                </Box>
            )}

            {(quote.vendor_note || quote.admin_note) && (
                <VStack mt={4} spacing={2} align="stretch">
                    {quote.vendor_note && (
                        <Box
                            p={3}
                            bg="orange.50"
                            borderRadius="xl"
                            border="1px solid"
                            borderColor="orange.100">
                            <Text
                                fontSize="10px"
                                color="orange.600"
                                fontWeight="700"
                                textTransform="uppercase"
                                letterSpacing="0.06em"
                                mb={1}>
                                Vendor Note
                            </Text>
                            <Text fontSize="sm" color="orange.800">
                                {quote.vendor_note}
                            </Text>
                        </Box>
                    )}
                    {quote.admin_note && (
                        <Box
                            p={3}
                            bg="blue.50"
                            borderRadius="xl"
                            border="1px solid"
                            borderColor="blue.100">
                            <Text
                                fontSize="10px"
                                color="blue.600"
                                fontWeight="700"
                                textTransform="uppercase"
                                letterSpacing="0.06em"
                                mb={1}>
                                Admin Note
                            </Text>
                            <Text fontSize="sm" color="blue.800">
                                {quote.admin_note}
                            </Text>
                        </Box>
                    )}
                </VStack>
            )}
        </Box>
    );
};

const Pagination = ({ page, total, limit, onPage }) => {
    const totalPages = Math.ceil(total / limit);
    if (totalPages <= 1) return null;
    return (
        <Flex
            align="center"
            justify="space-between"
            px={{ base: 3, md: 4 }}
            py={3}
            borderTop={`1px solid ${BORDER}`}
            flexWrap="wrap"
            gap={2}>
            <Text fontSize="xs" color="gray.400">
                Showing {(page - 1) * limit + 1}–{Math.min(page * limit, total)} of {total}
            </Text>
            <HStack spacing={1}>
                <IconButton
                    icon={<ChevronLeftIcon />}
                    size="sm"
                    variant="outline"
                    borderRadius="lg"
                    isDisabled={page <= 1}
                    onClick={() => onPage(page - 1)}
                    aria-label="Previous"
                />
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter((p) => p === 1 || p === totalPages || Math.abs(p - page) <= 1)
                    .reduce((acc, p, idx, arr) => {
                        if (idx > 0 && p - arr[idx - 1] > 1) acc.push('…');
                        acc.push(p);
                        return acc;
                    }, [])
                    .map((p, idx) =>
                        p === '…' ? (
                            <Text key={`e-${idx}`} fontSize="xs" color="gray.400" px={1}>
                                …
                            </Text>
                        ) : (
                            <Button
                                key={p}
                                size="sm"
                                borderRadius="lg"
                                variant={p === page ? 'solid' : 'outline'}
                                bg={p === page ? NAVY : undefined}
                                color={p === page ? 'white' : undefined}
                                _hover={{ bg: p === page ? NAVY2 : undefined }}
                                onClick={() => onPage(p)}>
                                {p}
                            </Button>
                        ),
                    )}
                <IconButton
                    icon={<ChevronRightIcon />}
                    size="sm"
                    variant="outline"
                    borderRadius="lg"
                    isDisabled={page >= totalPages}
                    onClick={() => onPage(page + 1)}
                    aria-label="Next"
                />
            </HStack>
        </Flex>
    );
};

const SampleRequest = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [view, setView] = useState('table');
    const [selectedProduct, setSelected] = useState([]);
    const [expandedRow, setExpanded] = useState(null);
    const [searchInput, setSearchInput] = useState('');
    const [customerContext, setCustomerContext] = useState(null);

    const { flattenedUser } = useGetUserDetails();
    const { sampleRequest, total, isLoading, page, goToPage, onSearch, refetch, PAGE_LIMIT } =
        useGetSampleRequest();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const activeTab = params.get('tab');
        if (!activeTab || activeTab === 'samplerequest') refetch();
    }, [location.search]);

    const handleSuccess = () => {
        refetch();
        setView('success');
        setSelected([]);
        setCustomerContext(null);
    };

    const handleSearch = (val) => {
        setSearchInput(val);
        onSearch(val);
    };

    if (view === 'success') {
        return (
            <Flex minH="60vh" direction="column" align="center" justify="center" px={4}>
                <Box
                    maxW="420px"
                    w="100%"
                    bg="white"
                    borderRadius="3xl"
                    p={{ base: 7, md: 10 }}
                    border={`1px solid ${BORDER}`}
                    shadow="xl"
                    textAlign="center">
                    <Box fontSize="5xl" mb={4}>
                        🎉
                    </Box>
                    <Text
                        fontWeight="800"
                        fontSize="2xl"
                        color={NAVY}
                        mb={2}
                        letterSpacing="-0.03em">
                        Request Submitted!
                    </Text>
                    <Text color="gray.500" fontSize="sm" mb={8} lineHeight="1.6">
                        Your sample request has been received. We'll get back to you shortly.
                    </Text>
                    <VStack spacing={3}>
                        <Button
                            bg={NAVY}
                            color="white"
                            _hover={{ bg: NAVY2 }}
                            borderRadius="xl"
                            w="100%"
                            onClick={() => setView('table')}>
                            View My Requests
                        </Button>
                        <Button
                            variant="outline"
                            borderRadius="xl"
                            w="100%"
                            onClick={() => navigate('/dashboard')}>
                            Back to Dashboard
                        </Button>
                    </VStack>
                </Box>
            </Flex>
        );
    }

    if (view === 'customer') {
        return (
            <Box
                maxW="480px"
                mx="auto"
                bg="white"
                borderRadius="3xl"
                border={`1px solid ${BORDER}`}
                shadow="sm"
                p={{ base: 5, md: 8 }}
                // mx={{ base: 3, md: 'auto' }}
            >
                <Flex align="center" justify="space-between" mb={6}>
                    <Box>
                        <Text fontWeight="800" fontSize="xl" color={NAVY} letterSpacing="-0.02em">
                            Sample Request
                        </Text>
                        <Text fontSize="sm" color="gray.500" mt="2px">
                            Step 1 — Select customer
                        </Text>
                    </Box>
                    <Button
                        size="sm"
                        variant="ghost"
                        colorScheme="red"
                        onClick={() => {
                            setCustomerContext(null);
                            setView('table');
                        }}>
                        ✕ Cancel
                    </Button>
                </Flex>
                <CustomerStep
                    onConfirm={(ctx) => {
                        setCustomerContext(ctx);
                        setView('form');
                    }}
                    onSkip={() => {
                        setCustomerContext(null);
                        setView('form');
                    }}
                />
            </Box>
        );
    }

    if (view === 'form') {
        return (
            <Box
                maxW="800px"
                mx={{ base: 0, md: 'auto' }}
                bg="white"
                borderRadius={{ base: '2xl', md: '3xl' }}
                border={`1px solid ${BORDER}`}
                shadow="sm"
                // mx={{ base: 3, md: 'auto' }}
                p={{ base: 4, md: 8 }}>
                <RequestFormView
                    selectedProduct={selectedProduct}
                    setSelectedProduct={setSelected}
                    onCancel={() => {
                        setView('customer');
                        setCustomerContext(null);
                    }}
                    onSuccess={handleSuccess}
                    flattenedUser={flattenedUser}
                    customerContext={customerContext}
                />
            </Box>
        );
    }

    return (
        <Box px={{ base: 0, md: 0 }}>
            <Flex
                justify="space-between"
                align={{ md: 'center' }}
                flexDir={{ base: 'column', md: 'row' }}
                mb={6}
                gap={3}>
                <Box>
                    <Flex gap={2} align="center" color={NAVY} mb={1}>
                        {oBIcons.sampleRequest}
                        <Text
                            fontSize={{ base: 'lg', md: 'xl' }}
                            fontWeight="800"
                            letterSpacing="-0.02em">
                            My Sample Requests
                        </Text>
                    </Flex>
                    <Text fontSize="sm" color="gray.500">
                        Track and manage all your sample requests
                    </Text>
                </Box>
                <Button
                    bg={NAVY}
                    color="white"
                    _hover={{ bg: NAVY2, transform: 'translateY(-1px)' }}
                    borderRadius="xl"
                    h="44px"
                    gap={2}
                    transition="all 0.2s"
                    alignSelf={{ base: 'flex-start', md: 'auto' }}
                    onClick={() => {
                        setSelected([]);
                        setCustomerContext(null);
                        setView('customer');
                    }}>
                    <PlusSquareIcon /> New Sample Request
                </Button>
            </Flex>

            {total > 0 && (
                <Flex
                    gap={3}
                    mb={6}
                    align="center"
                    bg="white"
                    borderRadius="2xl"
                    p={4}
                    border={`1px solid ${BORDER}`}
                    shadow="sm">
                    <Box>
                        <Text fontSize="2xl" fontWeight="800" color={NAVY}>
                            {total}
                        </Text>
                        <Text
                            fontSize="xs"
                            color="gray.400"
                            fontWeight="600"
                            textTransform="uppercase"
                            letterSpacing="0.06em">
                            Total Requests
                        </Text>
                    </Box>
                    <Divider orientation="vertical" h="40px" borderColor={BORDER} mx={2} />
                    <Text fontSize="sm" color="gray.500" display={{ base: 'none', md: 'block' }}>
                        Each request creates a Zoho sales order and sample item automatically.
                    </Text>
                </Flex>
            )}

            <Box mb={4}>
                <InputGroup maxW="400px">
                    <InputLeftElement pointerEvents="none">
                        <SearchIcon color="gray.400" />
                    </InputLeftElement>
                    <Input
                        placeholder="Search by product, order ref, or SKU…"
                        value={searchInput}
                        onChange={(e) => handleSearch(e.target.value)}
                        bg="white"
                        border={`1px solid ${BORDER}`}
                        borderRadius="xl"
                        _focus={{ borderColor: TEAL, boxShadow: `0 0 0 1px ${TEAL}` }}
                    />
                </InputGroup>
            </Box>

            {isLoading ? (
                <Loader />
            ) : !sampleRequest || isEmpty(sampleRequest) ? (
                <Flex
                    direction="column"
                    minH="40vh"
                    justify="center"
                    align="center"
                    bg="white"
                    borderRadius="3xl"
                    border={`1px solid ${BORDER}`}
                    p={10}>
                    <Text fontSize="4xl" mb={3}>
                        📋
                    </Text>
                    <Text fontWeight="700" color={NAVY} mb={1}>
                        {searchInput ? 'No results found' : 'No sample requests yet'}
                    </Text>
                    <Text fontSize="sm" color="gray.400" mb={6}>
                        {searchInput
                            ? 'Try a different search term'
                            : 'Create your first request to get started'}
                    </Text>
                    {!searchInput && (
                        <Button
                            bg={NAVY}
                            color="white"
                            _hover={{ bg: NAVY2 }}
                            borderRadius="xl"
                            onClick={() => {
                                setSelected([]);
                                setCustomerContext(null);
                                setView('customer');
                            }}>
                            + New Request
                        </Button>
                    )}
                </Flex>
            ) : (
                <Box
                    bg="white"
                    borderRadius="3xl"
                    border={`1px solid ${BORDER}`}
                    shadow="sm"
                    overflow="hidden">
                    <TableContainer>
                        <Table variant="simple" size="sm">
                            <Thead>
                                <Tr bg={SLATE}>
                                    <Th w="40px" />
                                    <Th
                                        py={4}
                                        color="gray.400"
                                        fontSize="10px"
                                        letterSpacing="0.06em">
                                        ORDER REF
                                    </Th>
                                    <Th
                                        py={4}
                                        color="gray.400"
                                        fontSize="10px"
                                        letterSpacing="0.06em">
                                        PRODUCT
                                    </Th>
                                    <Th
                                        py={4}
                                        color="gray.400"
                                        fontSize="10px"
                                        letterSpacing="0.06em"
                                        isNumeric
                                        display={{ base: 'none', md: 'table-cell' }}>
                                        DATE
                                    </Th>
                                    <Th
                                        py={4}
                                        color="gray.400"
                                        fontSize="10px"
                                        letterSpacing="0.06em"
                                        isNumeric>
                                        QTY
                                    </Th>
                                    <Th
                                        py={4}
                                        color="gray.400"
                                        fontSize="10px"
                                        letterSpacing="0.06em"
                                        display={{ base: 'none', md: 'table-cell' }}>
                                        PAYMENT
                                    </Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {sampleRequest.map((quote, i) => {
                                    const isExp = expandedRow === quote.id;
                                    return (
                                        <>
                                            <Tr
                                                key={quote.id ?? i}
                                                cursor="pointer"
                                                bg={isExp ? '#F0F7FF' : 'white'}
                                                _hover={{ bg: SLATE }}
                                                borderBottom={`1px solid ${BORDER}`}
                                                onClick={() => setExpanded(isExp ? null : quote.id)}
                                                transition="background 0.15s">
                                                <Td py={4} textAlign="center">
                                                    <Box
                                                        color="gray.400"
                                                        transition="transform 0.2s"
                                                        transform={
                                                            isExp ? 'rotate(180deg)' : 'rotate(0)'
                                                        }>
                                                        <ChevronDownIcon />
                                                    </Box>
                                                </Td>
                                                <Td py={4}>
                                                    <Text
                                                        fontSize="xs"
                                                        fontFamily="mono"
                                                        fontWeight="600"
                                                        color={NAVY}>
                                                        {quote.order_ref || '—'}
                                                    </Text>
                                                </Td>
                                                <Td py={4}>
                                                    <Flex align="center" gap={2}>
                                                        <Image
                                                            src={quote.product_image ?? p1}
                                                            fallbackSrc={p1}
                                                            w="34px"
                                                            h="34px"
                                                            objectFit="cover"
                                                            borderRadius="lg"
                                                            border={`1px solid ${BORDER}`}
                                                            flexShrink={0}
                                                        />
                                                        <Text
                                                            fontSize="sm"
                                                            fontWeight="600"
                                                            noOfLines={1}
                                                            color="gray.700"
                                                            maxW={{ base: '100px', md: '200px' }}>
                                                            {quote.product_name}
                                                        </Text>
                                                    </Flex>
                                                </Td>
                                                <Td
                                                    py={4}
                                                    isNumeric
                                                    display={{ base: 'none', md: 'table-cell' }}>
                                                    <Text fontSize="xs" color="gray.500">
                                                        {quote.createdAt
                                                            ? moment(quote.createdAt).format(
                                                                  'DD MMM YY',
                                                              )
                                                            : 'N/A'}
                                                    </Text>
                                                </Td>
                                                <Td py={4} isNumeric>
                                                    <Text
                                                        fontSize="sm"
                                                        fontWeight="700"
                                                        color={NAVY}>
                                                        {quote.qty ?? 1}
                                                    </Text>
                                                </Td>
                                                <Td
                                                    py={4}
                                                    display={{ base: 'none', md: 'table-cell' }}>
                                                    <Box
                                                        display="inline-block"
                                                        px={3}
                                                        py={1}
                                                        bg="#EEF3F9"
                                                        borderRadius="full"
                                                        fontSize="10px"
                                                        fontWeight="700"
                                                        color={NAVY}>
                                                        {quote.payment_method || 'POD'}
                                                    </Box>
                                                </Td>
                                            </Tr>
                                            {isExp && (
                                                <Tr key={`detail-${quote.id ?? i}`}>
                                                    <Td colSpan={6} p={0}>
                                                        <RequestDetailRow quote={quote} />
                                                    </Td>
                                                </Tr>
                                            )}
                                        </>
                                    );
                                })}
                            </Tbody>
                        </Table>
                    </TableContainer>
                    <Pagination page={page} total={total} limit={PAGE_LIMIT} onPage={goToPage} />
                </Box>
            )}
        </Box>
    );
};

export default SampleRequest;
